<div class="search-field">
	<app-icon type="svg" [size]="18" color="currentColor" aria-hidden="true">
		search
	</app-icon>
	<input
		#input
		type="text"
		class="search-field__input"
		placeholder="Search pages, campaigns, affiliates…"
		autocomplete="off"
		spellcheck="false"
		role="combobox"
		aria-label="Search"
		aria-autocomplete="list"
		[attr.aria-expanded]="rows.length > 0"
		[attr.aria-controls]="listboxId"
		[attr.aria-activedescendant]="activeId"
		[formControl]="query"
		(keydown)="onKeydown($event)"
	/>
	<button
		type="button"
		class="search-field__esc"
		aria-label="Close search"
		(click)="close()"
	>
		<kbd>esc</kbd>
	</button>
</div>

<div
	*ngIf="groups.length || recordsLoading"
	class="results"
	role="listbox"
	[id]="listboxId"
	aria-label="Search results"
>
	<ng-container *ngFor="let group of groups">
		<div
			*ngIf="group.key === 'elsewhere' && recordsLoading"
			class="group"
			aria-hidden="true"
		>
			<app-skeleton-loader
				*ngFor="let _ of 3 | times"
				class="group__skeleton"
				height="2.25rem"
				borderRadius="0.5rem"
			></app-skeleton-loader>
		</div>

		<div class="group" role="group" [attr.aria-label]="group.title">
			<typography variant="p/xxs_semibold" class="group__title">
				{{ group.title }}
			</typography>

			<typography
				*ngIf="group.notice"
				variant="p/sm_regular"
				class="group__notice"
			>
				{{ group.notice }}
			</typography>

			<button
				*ngFor="let row of group.rows"
				type="button"
				class="row"
				role="option"
				tabindex="-1"
				[id]="row.domId"
				[class.row--active]="row.domId === activeId"
				[attr.aria-selected]="row.domId === activeId"
				(mousedown)="$event.preventDefault()"
				(click)="row.follow()"
			>
				<app-icon
					class="row__icon"
					type="svg"
					[size]="16"
					color="currentColor"
					aria-hidden="true"
				>
					{{ row.icon }}
				</app-icon>
				<typography variant="p/sm_medium" class="row__text">
					<!-- TRAP: text through [textContent] — a formatter that wraps {{ }} onto its own line puts spaces inside the mark. -->
					<span
						*ngIf="row.prefix"
						class="row__prefix"
						[textContent]="row.prefix"
					></span>
					<ng-container *ngFor="let part of row.parts">
						<mark
							*ngIf="part.matched"
							class="row__match"
							[textContent]="part.text"
						></mark>
						<span
							*ngIf="!part.matched"
							[textContent]="part.text"
						></span>
					</ng-container>
				</typography>
				<typography
					*ngIf="row.caption"
					variant="p/xs_regular"
					class="row__caption"
					[matTooltip]="row.caption"
					matTooltipPosition="above"
				>
					{{ row.caption }}
				</typography>
				<typography
					*ngIf="row.handOff"
					variant="p/xs_medium"
					class="row__hand-off"
				>
					{{ row.handOff }}
				</typography>
			</button>
		</div>
	</ng-container>
</div>

<div class="hints" aria-hidden="true">
	<span class="hint">
		<kbd>↑</kbd>
		<kbd>↓</kbd>
		<typography variant="p/xxs_medium">move</typography>
	</span>
	<span class="hint">
		<kbd>↵</kbd>
		<typography variant="p/xxs_medium">open</typography>
	</span>
	<span class="hint">
		<kbd>esc</kbd>
		<typography variant="p/xxs_medium">close</typography>
	</span>
</div>
